import { useEffect, useState } from "react";
import { useApp } from "../../../hooks/AppProvider";
import { AddButtonCell, EditDeleteCell, InputCell, NewRowTemplate, RedirectButtonCell, Table } from "../../../components/BasicComponents";
import BehaviorTerms from "./BehaviorTerms";

function BehaviorGroupsTable({ groups, assignments, onDelete, onUpdate, onAdd }) {
    return (
        <Table headers={["Nom du groupe", "Composition", "Autre", ""]}>
            {groups && groups.map(group => (
                <BehaviorGroupsRow
                    key={"groups:"+group.id}
                    id={group.id}
                    name={group.name}
                    onDelete={onDelete}
                    onUpdate={onUpdate}
                    assignments={assignments.filter(val => val.group_id+"" === group.id+"")}
                />
            ))}
            <BehaviorGroupsNewRow onAdd={onAdd} />
        </Table>
    )
}

function BehaviorGroupsRow({ id, name, assignments, onDelete, onUpdate }) {

    const app = useApp();

    const [name0, setName0] = useState(name);
    const [change, setChange] = useState(false);

    const onDelete0 = () => {
        if(window.confirm("Vous êtes sur le point de supprimer le groupe: " + name + ". Souhaitez-vous continuer ?")) {
            onDelete(id);
        }
    };

    const onUpdate0 = () => {
        if(app.emptyCheck(name0))
            return alert("Le nouveau nom est vide");
        
        onUpdate(id, name0);
        setChange(false);
    };

    return (
        <tr>
            <InputCell
                type="text"
                value={name0}
                onChange={e => {setName0(e.target.value); setChange(true)}}
            />
            <td>
                <Table>
                    {assignments.map(assignment => (
                        <tr key={"assignments:" + assignment.id}>
                            <td>
                                {assignment.student_name}
                            </td>
                        </tr>
                    ))}
                </Table>
            </td>
            <RedirectButtonCell
                redirectTo={id + "/"}
                text={"Détail"}
            />
            <EditDeleteCell
                change={change}
                onDelete={onDelete0}
                onEdit={onUpdate0}
            />
        </tr>
    );
}

function BehaviorGroupsNewRow({ onAdd }) {
    
    const [newName, setNewName] = useState("");

    const onAdd0 = () => {
        onAdd(newName);
        setNewName("");
    };

    return (
        <NewRowTemplate>
            <InputCell
                value={newName}
                placeholder="Nom du groupe"
                onChange={e => setNewName(e.target.value)}
                type="text"
            />
            <td></td>
            <td></td>
            <AddButtonCell onAdd={onAdd0} />
        </NewRowTemplate>
    )
}

function BehaviorGroupsConfigurationsTable({ configurations, onUpdate }) {

    return (
        <Table>
            {configurations.map(config => (
                <BehaviorGroupsConfigurationsRow key={config.id} id={config.id} name={config.name} type={config.type} value={config.value} onUpdate={onUpdate} />
            ))}
        </Table>
    )
}

function BehaviorGroupsConfigurationsRow({ id, name, type, value, onUpdate }) {

    const app = useApp();
    const [value0, setValue0] = useState(value);
    const [disabled, setDisabled] = useState(true);

    const onUpdate0 = () => {
        if(value0 < 0) {
            return alert("La valeur ne peut pas être inférieur à 0 !");
        }
        onUpdate(id, value0);
        setDisabled(true);
    };

    return (
        <tr>
            <td>
                <span>{name}</span>
            </td>
            <InputCell 
                value={value0}
                onChange={e => {setValue0(e.target.value); setDisabled(false);}}
                type={type}
                min={1}
            />
            <EditDeleteCell change={true} disable={true} onEdit={onUpdate0} disabled={disabled} />
        </tr>
    )
}

function BehaviorGroupsConfigurations() {

    const app = useApp();
    const [configurations, setConfigurations] = useState([]);

    useEffect(() => {
        app.sendGet("/behavior/configurations", data => {
            updateConfigureations(data)
        });
    }, []);

    const updateConfigureations = (data) => {
        setConfigurations([
            {
                id: "daily-pts",
                name: "Points journaliers",
                type: "number",
                value: data.daily_points
            }
        ]);
    }

    const onUpdateConfiguration = (id, newValue) => {
        const updateObject = {};

        switch(id) {
            case "daily-pts":
                if(newValue <= 0)
                    return alert("Les points journaliers doivent être positif.");
                updateObject.daily_points = newValue;
        }

        app.sendPost("/behavior/configurations/update", updateObject, data => {
            updateConfigureations(data);
        });
    }

    return (
        <div>
            <h2>Configurations</h2>
            <BehaviorGroupsConfigurationsTable configurations={configurations} onUpdate={onUpdateConfiguration} />
        </div>
    )
}

function BehaviorGroups() {

    const app = useApp();

    const [groups, setGroups] = useState([]);
    const [assignments, setAssignments] = useState([]);

    useEffect(() => {
        app.sendGet("/behavior/list", data => {
            setGroups(data);
        });

         app.sendGet("/behavior/assignments", data => {
            setAssignments(data);
        });
    }, []);

    const onDeleteGroup = (groupId) => {
        app.sendPost("/behavior/delete", {id: groupId}, data => {
            if(data.success === true)
                setGroups(groups.filter(val => val.id !== groupId));
            else
                alert("Une erreur s'est produite [0]")
        });
    };

    const onUpdateGroup = (id, newName) => {
        app.sendPost("/behavior/update", {id: id, name: newName}, data => {
            setGroups(groups.map(val => val.id===id?({...val, name: newName}):val));
        });
    };

    const onAddGroup = (newName) => {
        if(app.emptyCheck(newName))
            return alert("Le nouveau nom est vide");

        app.sendPost("/behavior/add", {name: newName}, data => {
            setGroups([...groups, data]);
        });
    };

    return (
        <div>
            <h1>Groupes</h1>
            <BehaviorGroupsTable
                groups={groups}
                assignments={assignments}
                onDelete={onDeleteGroup}
                onUpdate={onUpdateGroup}
                onAdd={onAddGroup}
            />
            <hr />
            <BehaviorTerms />
            <hr />
            <BehaviorGroupsConfigurations />
        </div>
    )
}

export default BehaviorGroups;